
import { User } from '@/models/User';
import useQuickInfo, { QuickInfoSections } from '@/state/quickInfo';
import { defineComponent, PropType, toRefs } from 'vue';
import { templateRef } from '@vueuse/core';

export default defineComponent({
  name: 'BCXLinkedUser',
  props: {
    user: {
      type: Object as PropType<User>,
      default: null
    },
    tag: {
      type: String,
      default: 'span'
    },
    quickInfoSection: {
      type: String as PropType<QuickInfoSections>,
      default: 'contact-history'
    }
  },
  setup(props) {
    const { user } = toRefs(props);
    const el = templateRef<HTMLElement>('el');
    const { showQuickInfo } = useQuickInfo();

    const showProfile = () => {
      showQuickInfo(el, user.value, props.quickInfoSection);
    };

    return {
      showProfile
    };
  }
});
